import { Fragment } from 'react';
import CloverMakeEditsModal from './components/CloverMakeEditsModal';
import CloverPublishModal from './components/CloverPublishModal';
import DaySmartPublishModal from './components/DaySmartPublishModal';
import PublishModal from './components/PublishModal';
import RequestEditModal from './components/RequestEditModal';
var publishModalComponentFromCollectionMethod = {
  CloverMarketplace: CloverPublishModal,
  DaySmart: DaySmartPublishModal
};
var requestEditModalCompomentFromCollectionMethod = {
  CloverMarketplace: CloverMakeEditsModal,
  DaySmart: Fragment
};
var publishModalPropsFromCollectionMethod = {
  CloverMarketplace: function CloverMarketplace(_ref) {
    var state = _ref.state,
        handlePublishOpen = _ref.handlePublishOpen,
        handlePublishClose = _ref.handlePublishClose;
    return {
      open: state.showPublishModal,
      onOpen: handlePublishOpen,
      onClose: handlePublishClose
    };
  },
  DaySmart: function DaySmart(_ref2) {
    var state = _ref2.state,
        props = _ref2.props,
        handlePublishOpen = _ref2.handlePublishOpen,
        handlePublishClose = _ref2.handlePublishClose;
    return {
      open: state.showPublishModal,
      onOpen: handlePublishOpen,
      onClose: handlePublishClose,
      defaultDomain: props.defaultDomain,
      business: props.business
    };
  }
};

var getDefaultPublishModalProps = function getDefaultPublishModalProps(_ref3) {
  var props = _ref3.props,
      state = _ref3.state,
      handlePublishOpen = _ref3.handlePublishOpen,
      handlePublishClose = _ref3.handlePublishClose,
      onCheckoutCompleted = _ref3.onCheckoutCompleted;
  return {
    showPublishModal: state.showPublishModal,
    handlePublishOpen: handlePublishOpen,
    handlePublishClose: handlePublishClose,
    onCheckoutCompleted: onCheckoutCompleted,
    business: props.business,
    defaultDomain: props.defaultDomain,
    checkedOut: state.checkedOut,
    collectEmail: props.collectEmail,
    domains: state.domains
  };
};

export function getPublishModalPropsFromCollectionMethod(collectionMethod, component) {
  var propsGetter = publishModalPropsFromCollectionMethod[collectionMethod] || getDefaultPublishModalProps;
  return propsGetter(component);
}
export function getPublishModalComponentFromCollectionMethod(collectionMethod) {
  return publishModalComponentFromCollectionMethod[collectionMethod] || PublishModal;
}
var RequestEditModalPropsFromCollectionMethod = {
  CloverMarketplace: function CloverMarketplace(_ref4) {
    var state = _ref4.state,
        handleRequestOpen = _ref4.handleRequestOpen,
        handleRequestClose = _ref4.handleRequestClose;
    return {
      open: state.showRequestEditModal,
      onOpen: handleRequestOpen,
      onClose: handleRequestClose
    };
  },
  DaySmart: function DaySmart() {
    return {};
  }
};

var getDefaultRequestEditModalProps = function getDefaultRequestEditModalProps(_ref5) {
  var props = _ref5.props,
      state = _ref5.state,
      handleRequestOpen = _ref5.handleRequestOpen,
      handleRequestClose = _ref5.handleRequestClose,
      handlePublishOpen = _ref5.handlePublishOpen;
  return {
    open: state.showRequestEditModal,
    onOpen: handleRequestOpen,
    onClose: handleRequestClose,
    handlePublishOpen: handlePublishOpen,
    business: props.business,
    showRequesterInformation: props.showRequesterInformation
  };
};

export function getRequestEditModalPropsFromCollectionMethod(collectionMethod, component) {
  var propsGetter = RequestEditModalPropsFromCollectionMethod[collectionMethod] || getDefaultRequestEditModalProps;
  return propsGetter(component);
}
export function getRequestEditModalComponentFromCollectionMethod(collectionMethod) {
  return requestEditModalCompomentFromCollectionMethod[collectionMethod] || RequestEditModal;
}